import PrefilledLogin from "src/modules/auth/scenes/PrefilledLogin";
import SignUp from "src/modules/auth/scenes/SignUp";
import Login from "src/modules/auth/scenes/Login";
import PurchaseSuccess from "../scenes/Success";
import Buy from "../scenes/Buy";
import EnterToken from "../scenes/EnterToken";
import Help from "../scenes/Help";

export default [
  {
    id: "buy",
    Component: (props) => <Buy {...props} />
  },
  {
    id: "enter-token",
    Component: (props) => {
      const locationState = props.flow.state;
      return (
        <EnterToken
          {...props}
          isRestore={
            props.initialStep === "enter-token" || locationState.isRestore
          }
        />
      );
    }
  },
  {
    id: "help",
    Component: Help
  },
  {
    id: "purchase-success",
    Component: PurchaseSuccess
  },
  {
    id: "prefilled-login",
    Component: ({ flow, onClose, flowState }) => (
      <PrefilledLogin
        onBack={flow.previous}
        onSuccess={onClose}
        email={flowState.email}
      />
    )
  },

  {
    id: "sign-up",
    Component: ({ flow, flowState }) => (
      <SignUp
        flow={flow}
        email={flowState.email}
        onSuccess={() => flow.push("buy")}
        onBack={() => flow.push("buy", { direction: "previous" })}
        openLogin={() => flow.push("login")}
      />
    )
  },
  {
    id: "login",
    Component: ({ flowState, flow }) => (
      <Login
        flow={flow}
        email={flowState.email}
        onBack={flow.previous}
        onSuccess={() => flow.push("buy")}
      />
    )
  }
];
